import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserTeacher/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserTeacher/Get',
      params,
    });
  },
  GetByEmployeeNo(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserTeacher/GetByEmployeeNo',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserTeacher/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserTeacher/Update',
      data,
    });
  },
  Disable(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserTeacher/Disable',
      data,
    });
  },
  ChangePermission(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserTeacher/ChangePermission',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
